<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />
    <h5>Asistente para el registro de Citas</h5>
    <div style="display:flex; justify-content:space-between; align-items:center;
                background-color:#f0f0f0; padding:10px; border-radius:5px;">
      <h4 class="mb-0">Paso 3: Resumen de la cita</h4>
      <span class="badge-tipo"
            :class="datoCita.tipoIngreso === 'Admisión' ? 'badge-tipo--admision' : 'badge-tipo--agendamiento'">
        {{ datoCita.tipoIngreso || 'Agendamiento' }}
      </span>
    </div>
    <hr>

    <!-- Estado de carga -->
    <div v-if="cargando" class="text-center py-5 text-muted">
      <span class="material-symbols-outlined" style="font-size:40px;">hourglass_top</span>
      <p class="mt-2">Cargando resumen...</p>
    </div>

    <!-- Resumen -->
    <div v-else class="resumen-wrapper">
      <div class="resumen-body">
        <!-- Cabecera de éxito -->
        <div class="resumen-exito mb-4">
          <span class="material-symbols-outlined resumen-exito__icono">check_circle</span>
          <div>
            <p class="resumen-exito__titulo">Cita registrada exitosamente</p>
            <p class="resumen-exito__subtitulo">
              Cita N° <strong>{{ datoCita.numero }}</strong> —
              {{ getFormattedDate(datoCita.fechaCita) }},
              {{ datoCita.horaDesde }} a {{ datoCita.horaHasta }}
            </p>
          </div>
        </div>

        <!-- Grilla de campos -->
        <div class="resumen-grid">
          <div class="resumen-campo" v-for="campo in camposResumen" :key="campo.label">
            <span class="resumen-campo__label">{{ campo.label }}</span>
            <span class="resumen-campo__valor">{{ campo.valor || '—' }}</span>
          </div>
        </div>
      </div>

      <div class="resumen-footer">
        <div class="w-100 d-flex justify-content-between align-items-center flex-wrap gap-2">
          <!-- Grupo izquierdo -->
          <div class="d-flex gap-2 flex-wrap">
            <button type="button" class="btn btn-primary d-flex align-items-center gap-1"
                    @click="irACitas" title="Ver lista de agendamiento y admisión">
              <i class="material-icons" style="font-size:20px;">event</i>
              Agendamiento y Admisión
            </button>
            <button type="button" class="btn btn-outline-primary d-flex align-items-center gap-1"
                    @click="irAAtenciones" title="Ver lista de atenciones">
              <i class="material-icons" style="font-size:20px;">list_alt</i>
              Atenciones
            </button>
            <button type="button" class="btn btn-outline-secondary d-flex align-items-center gap-1"
                    @click="nuevaCita" title="Registrar otra cita">
              <i class="material-icons" style="font-size:20px;">add_circle</i>
              Nueva cita
            </button>
          </div>

          <!-- Grupo derecho -->
          <div class="d-flex gap-2 flex-wrap">
            <!-- Iniciar Cita — solo para Admisión -->
            <button
              v-if="datoCita.tipoIngreso === 'Admisión'"
              type="button"
              class="btn btn-info text-white d-flex align-items-center gap-1"
              @click="iniciarCita"
              title="Iniciar la cita y crear registro de atención"
            >
              <i class="material-icons" style="font-size:20px;">play_circle</i>
              Iniciar Cita
            </button>

            <!-- Volver a atención (solo si viene desde una atención) -->
            <button
              v-if="Number(p_idAtencion) > 0"
              type="button"
              class="btn btn-success d-flex align-items-center gap-1"
              @click="irAtencionSeleccionada"
              title="Volver a la atención"
            >
              <i class="material-icons" style="font-size:20px;">check_circle</i>
              Volver a la Atención
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout     from '@/components/Layout.vue'
import Footer     from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'
import swal2      from 'sweetalert2'

export default {
  name: 'PacienteCita03',
  props: {
    p_idCita: { type: Number, required: true },
  },
  components: { Layout, Footer },
  data() {
    return {
      datoCita:     {},
      cargando:     true,
      p_idAtencion: 0,
    }
  },
  computed: {
    camposResumen() {
      return [
        { label: 'Número de cita',  valor: this.datoCita.numero },
        { label: 'Tipo de ingreso', valor: this.datoCita.tipoIngreso },
        { label: 'Paciente',        valor: this.datoCita.nombrePaciente },
        { label: 'Especialidad',    valor: this.datoCita.nombreEspecialidad },
        { label: 'Médico',          valor: this.datoCita.nombreMedico },
        { label: 'Fecha',           valor: this.getFormattedDate(this.datoCita.fechaCita) },
        { label: 'Hora desde',      valor: this.datoCita.horaDesde },
        { label: 'Hora hasta',      valor: this.datoCita.horaHasta },
        { label: 'Motivo',          valor: this.datoCita.nombreMotivoCita },
        { label: 'Descripción',     valor: this.datoCita.descripcion },
      ]
    },
  },
  mounted() {
    this.p_idAtencion = window.sessionStorage.getItem('idAtencion') ?? 0
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    this.fetchCita()

    history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', this.bloquearNavegacion);
  },

  beforeUnmount() {
    window.removeEventListener('popstate', this.bloquearNavegacion);
  },
 
  methods: {
    bloquearNavegacion() {
      history.pushState(null, '', window.location.href);
    },

    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },
    fetchCita() {
      this.cargando = true
      api.get(`/vwcitas/${this.p_idCita}`)
        .then(r  => { this.datoCita = r.data })
        .catch(e => console.error('Error al obtener la cita:', e))
        .finally(() => { this.cargando = false })
    },

    // ── Navegación ─────────────────────────────────────────────────────────
    irACitas()               { this.$router.push('/cita') },
    irAAtenciones()          { this.$router.push('/atencion') },
    nuevaCita()              { this.$router.push('/pacientecita01/0') },
    irAtencionSeleccionada() {
      this.$router.push({
        name: 'AtencionForm',
        state: {
          idAtencion: this.p_idAtencion,
        }
      });
    },
    // ── Iniciar Cita (EN PROCESO) ──────────────────────────────────────────
    iniciarCita() {
      this.actualizarEstadoCita(this.p_idCita, 'EN PROCESO')
    },

    async actualizarEstadoCita(idCita, nuevoEstado) {
      // Confirmación previa
      const { isConfirmed } = await swal2.fire({
        title:             '¿Iniciar la cita?',
        text:              'Se creará automáticamente un registro de atención.',
        icon:              'question',
        confirmButtonText: 'Sí, iniciar',
        confirmButtonColor:'#6eaff2',
        showCancelButton:  true,
        cancelButtonText:  'Cancelar',
        cancelButtonColor: '#6c757d',
      })
      if (!isConfirmed) return

      // Loading mientras se procesa
      swal2.fire({
        title:             'Iniciando cita...',
        text:              'Por favor espera mientras se crea el registro de atención.',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen:          () => swal2.showLoading(),
      })

      try {
        const { data: cita }        = await api.get(`/citas/${idCita}`)
        const { data: atencionDto } = await api.post(
          `/citas/actestadocita?estadoCita=${nuevoEstado}&idUsuario=${window.sessionStorage.getItem('idUsuario')}`,
          cita
        )

        const result = await swal2.fire({
          title:             '¡Cita iniciada!',
          html:              `La cita N° <b>${cita.numero}</b> fue iniciada.<br>
                              Se creó el registro de atención N° <b>${atencionDto.numero}</b>.`,
          icon:              'success',
          confirmButtonText: `Abrir atención ${atencionDto.numero}`,
          showCancelButton:  true,
          showDenyButton:    true,
          denyButtonText:    'Nueva cita',
          cancelButtonText:  'Cerrar',
          confirmButtonColor:'#3085d6',
          denyButtonColor:   '#78c2ad',
          cancelButtonColor: '#6c757d',
        })

        if (result.isConfirmed)   this.$router.push(`/atencionform/${atencionDto.idAtencion}`)
        else if (result.isDenied) this.$router.push('/pacientecita01/0')

      } catch (error) {
        swal2.fire({
          title: 'Error',
          text:  'No se pudo iniciar la cita.',
          icon:  'error',
        })
        console.error('Error al iniciar cita:', error)
      }
    },
  },
}
</script>

<style src="@/assets/css/wizardResumen.css" scoped></style>
<style scoped>
/* Reemplaza modal-dialog/modal-content con clases propias */
.resumen-wrapper {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  overflow: hidden;
  background: #fff;
  max-width: 1140px;
  margin: 0 auto;
}
.resumen-body   { padding: 1.5rem; }
.resumen-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #dee2e6;
  background: #f8f9fa;
}

/* Cabecera de éxito */
.resumen-exito {
  display: flex; align-items: flex-start; gap: 12px;
  background-color: #eafaf1; border: 1px solid #a9dfbf;
  border-radius: 8px; padding: 14px 18px;
}
.resumen-exito__icono    { font-size: 36px; color: #27ae60; flex-shrink: 0; }
.resumen-exito__titulo   { font-weight: 600; font-size: 1rem; color: #1e8449; margin: 0; }
.resumen-exito__subtitulo{ font-size: 0.88rem; color: #555; margin: 2px 0 0; }

/* Grilla de campos */
.resumen-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 0; }
.resumen-campo {
  display: flex; flex-direction: column;
  padding: 10px 16px; border-bottom: 1px solid #e9ecef;
}
.resumen-campo:nth-child(odd)  { border-right: 1px solid #e9ecef; }
.resumen-campo__label {
  font-size: 0.75rem; font-weight: 600; color: #6c757d;
  text-transform: uppercase; letter-spacing: 0.04em; margin-bottom: 2px;
}
.resumen-campo__valor { font-size: 0.95rem; color: #212529; text-transform: uppercase; }

/* Badges tipo ingreso */
.badge-tipo { display: inline-block; padding: 4px 14px; border-radius: 20px; font-size: 0.82rem; font-weight: 600; }
.badge-tipo--agendamiento { background-color: #a2cf6e; color: #1a3d00; }
.badge-tipo--admision     { background-color: #f7d08a; color: #5a3e00; }

@media (max-width: 576px) {
  .resumen-grid { grid-template-columns: 1fr; }
  .resumen-campo:nth-child(odd) { border-right: none; }
}
</style>